/*
 * @FilePath     : /es-template/src/common/publicParams.js
 * @Author       : LiYang
 * @Date         : 2021-09-14 20:59:56
 * @LastEditTime: 2023-08-22 21:21:58
 * @LastEditors: liuziwei
 * @Description  : 请求公共参数
 */

import { now, tranver } from '@/common/sig'
import { trackEvent } from '@/common/track';
import store from '@/store'
import { mpx } from '@didi/es-mpx-creator'
import { source_channel } from './source_channel'
import { xenv } from '@didi/webx-js'
import { getStorage } from '@/utils/storage'

export const sec = '20171abe34fc14653634f59a57e90d10'

export const publicParams = {
  // from: 'h5',
  app_id: 'esapp_h5',
  datatype: '101',
  // source_id: '101',
  encrypt_method: 'md5',
  // key: '88b5cfe102493935da737a900d989ad0'
}

export const getPublick = ({ token, ...other }, url = '') => {
  const ticket = store?.state?.user?.token || store?.state?.user?.userInfo?.token || mpx.getStorageSync('token')
  const mpxTicket = mpx.getStorageSync('token')
  
  const timestamp = now()
  const versionKey = url?.includes('/category/') ? 'version' : 'app_version'
  const locationInfo = store?.state?.common?.locationInfo
  const envFrom = xenv()
  
  if (!mpxTicket) {
    try {
      // 埋点 ticket缺失排查
      trackEvent('yks_local_storage_set_or_get_ck', 'yks_local_storage_set_or_get_ck', {
        type: 'request_no_ticket',
        url,
        env_from: envFrom,
        host: window.location.host,
        // 登录状态
        is_login: store?.state?.user?.isLogin ? '1' : '0',
        single_t: store?.state?.user?.token ? '1' : '0',
        user_t: store?.state?.user?.userInfo?.token ? '1' : '0',
        local_storage_t: getStorage('token') ? '1' : '0',
        local_storage_user_t: getStorage('userInfo')?.token ? '1' : '0'
      })
    } catch (e) {
      console.log('上报出错了', e)
    }
  }

  publicParams.supplier_id = store?.state?.train?.supplierId
  // 添加容器来源 参数
  publicParams.source_channel = source_channel()

    if (__mpx_mode__ === 'web' && window.__wxjs_environment === 'miniprogram') {
      // 在微信小程序中打开(appid,key)及支付
      publicParams.app_id = 'esapp_applet_h5'
      publicParams.key = 'efd409b0676d4db5dd0e6e69efe2e1f6'
    } {
      // 默认
      publicParams.app_id = 'esapp_h5'
      publicParams.key = '88b5cfe102493935da737a900d989ad0'
    }
 
  return tranver({
    ...publicParams,
    [versionKey]: '3.3.4',
    timestamp,
    envFrom,
    ticket: token ?? ticket,
    city_id: locationInfo?.cityId ?? -1,
    app_time: Math.floor(timestamp / 1000),
    ...other,
  })
}
